import { isOrderBalProduct } from '@kariusdx/utils';
import getConfig from 'next/config';
import { Form } from '../EtrfOrder/utils/TrfDto.interface';
import { TRFGqlModel } from '../graphql/query/trfInfo';

const { publicRuntimeConfig } = getConfig();

export const isServerSide = () => {
  return typeof window === 'undefined';
};

export const isClientSide = () => {
  return !isServerSide();
};

const isJestRunning = () => process.env.JEST_WORKER_ID !== undefined;
const isCypressRunning = () => !!(typeof window !== 'undefined' && (window as any)?.Cypress);

export const isTestRunning = () => isJestRunning() || isCypressRunning();

export const VerboseLoggingOn = publicRuntimeConfig.verbose;

export const getPageName = () => {
  if (isServerSide()) return 'SERVER';
  const pathname = window.location.pathname;
  if (pathname.match(/\/orders\/\d*[/]?$/)) return 'order_detail_page';
  if (pathname.match(/\/orders\/\d*\/edit/)) return 'edit_trf';
  if (pathname.match(/\/orders\/\d*\/confirmation/)) return 'trf_submitted';
  switch (pathname) {
    case '/orders': {
      return 'order_list';
    }
    case '/orders/new': {
      return 'trf';
    }
    case '/kits/new': {
      return 'kit_order';
    }
    case '/login': {
      return 'sign_in';
    }
    default: {
      return pathname;
    }
  }
};

export const getTestName = (productName: string) => {
  return isOrderBalProduct(productName) ? 'focus_bal' : 'karius_test';
};

export const getCommonTrfAnalytics = (order: Form | TRFGqlModel | null | undefined) => ({
  id: order?.id ?? 'no_value',
  testRequestId: order?.testRequestId ?? 'no_value',
  test: order?.productName ? getTestName(order.productName) : 'no_value',
});
